
const States = {

    Company: 0,
    Companies: [],
    User: '',
    Module: '',
    DownPayment: '',
    OrganizationId: '',
    Organizations: [],
    NIT: '',
    ProductDownPayment: '',
    // PRUEBA TEMPORAL de Auth0 Organizations (ver conversacion): Access Token scoped a la
    // Empresa activa (pedido via getAccessTokenWithPopup en CompaniesShow.jsx), no persiste
    // en localStorage a proposito -- es un token, no un dato de UI, y expira -- si se pierde
    // en un refresh, CompaniesShow.jsx lo vuelve a pedir solo al re-montar.
    CompanyToken: '',
    // org_id de Auth0 (empresas.ID_Organizacion_AUTH0) al que quedo scoped CompanyToken de
    // arriba -- se guarda junto con el token para que fetchCompanyOrgToken (CompanyAuth.js)
    // pueda darse cuenta si el token en cache es de OTRA Empresa antes de reusarlo. Antes de
    // que el org_id se resolviera por Empresa (estaba quemado a Vecame para todas), esto no
    // hacia falta -- un token en cache era siempre valido para cualquier Empresa porque
    // todas "eran" la misma organizacion de Auth0. Ahora que cada Empresa tiene su propio
    // org_id, entrar a la Empresa B con el token en cache de la Empresa A (todavia no
    // vencido) traeria los permissions de A, no de B -- este campo es lo que evita eso.
    CompanyTokenOrgId: '',

    setCompanyToken: (token) => {
        States.CompanyToken = token;
    },

    getCompanyToken: () => {
        return States.CompanyToken;
    },

    setCompanyTokenOrgId: (orgId) => {
        States.CompanyTokenOrgId = orgId;
    },

    getCompanyTokenOrgId: () => {
        return States.CompanyTokenOrgId;
    },

    // Claim "permissions" del CompanyToken de arriba, ya decodificado (ver
    // fetchCompanyOrgToken en Commons/CompanyAuth.js) -- reemplaza los chequeos que antes
    // iban al API (dataProvider.auth('Auth', {id, data:{action}})), que a su vez llamaba a
    // la Management API de Auth0 buscando permisos del esquema viejo por NIT, desconectado
    // de InternalJWT. Mismo criterio que CompanyToken: no persiste en localStorage, es un
    // dato derivado del token, no de UI.
    Permissions: [],

    setPermissions: (permissions) => {
        States.Permissions = permissions || [];
    },

    getPermissions: () => {
        return States.Permissions;
    },

    setOrganizations: (organizations) => {
        States.Organizations = organizations;
        localStorage.setItem('Organizations', organizations);
    },

    getOrganizations: () => {
        let local = localStorage.getItem('Organizations');
        if (States.Organizations === '' && local !== '')
            return local;
        return States.Organizations;
    },

    setOrganizationId: (organizationId) => {
        States.OrganizationId = organizationId;
        localStorage.setItem('OrganizationId', organizationId);
    },

    getOrganizationId: () => {
        let local = localStorage.getItem('Organizations');
        if (States.Organizations === '' && local !== '')
            return local;
        return States.OrganizationId;
    },

    setNIT: (NIT) => {
        States.NIT = NIT;
        localStorage.setItem('NIT', NIT);
    },

    getNIT: () => {
        let local = localStorage.getItem('NIT');
        if (States.NIT === '' && local !== '')
            return local;
        return States.NIT;
    },

    setDownPayment: (downpayment) => {
        States.DownPayment = downpayment;
        localStorage.setItem('DownPayment', downpayment);
    },

    getDownPayment: () => {
        let local = localStorage.getItem('DownPayment');
        if (States.DownPayment === '' && local !== '')
            return local;
        return States.DownPayment;
    },

    setUser: (user) => {
        States.User = user;
        localStorage.setItem('User', user);
    },

    getUser: () => {
        let local = localStorage.getItem('User');
        if (States.User === '' && local !== '')
            return local;
        return States.User;
    },

    setModule: (module) => {
        States.Module = module;
        localStorage.setItem('Module', module);
    },

    getModule: () => {
        let local = localStorage.getItem('Module');
        if (States.Module === '' && local !== '')
            return local;
        return States.Module;
    },

    setCompany: (company) => {
        States.Company = company;
        localStorage.setItem('Company', company);
    },

    getCompany: () => {
        let local = localStorage.getItem('Company');
        if (States.Company === '' && local !== '')
            return local;
        return States.Company;
    },

    setCompanies: (companies) => {
        States.Companies = companies;
        localStorage.setItem('Companies', companies);
    },

    getCompanies: () => {
        let local = localStorage.getItem('Companies');
        if (States.Companies === '' && local !== '')
            return local;
        return States.Companies;
    },

    setProductDownPayment: (productDownPayment) => {
        States.ProductDownPayment = productDownPayment;
        localStorage.setItem('ProductDownPayment', productDownPayment);
    },

    getProductDownPayment: () => {
        let local = localStorage.getItem('ProductDownPayment');
        if (States.ProductDownPayment === '' && local !== '')
            return local;
        return States.ProductDownPayment;
    },
};

export default States;